// src/socket.js
import { io } from 'socket.io-client';

// Replace with your backend URL
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:8080';

let socket = null;

export const connectSocket = (userId) => {
  if (!socket) {
    socket = io(SOCKET_URL, { transports: ['websocket'] });
    socket.on('connect', () => {
      if (userId) {
        socket.emit('join', userId);
      }
    });
  }
  return socket;
};

export const getSocket = () => {
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
